export default __webpack_public_path__ + "static/media/showroom_black_nonum.2e3ed15f.png";